import React from "react";
import {  FaTimes } from 'react-icons/fa';

export default function AddEditOrganizationPopup({ customer, onClose }) {
    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-4/5 md:w-1/2 p-6">
                <div className=' flex justify-between item-center'>
                    <h2 className="text-lg font-semibold mb-4">{customer ? 'Edit Organization' : 'Add Organization'}</h2>
                    <button onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
                <form>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Name</label>
                        <input type="text" defaultValue={customer?.name || ''} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <input type="email" defaultValue={customer?.email || ''} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <button type="button" onClick={onClose} className="mt-4 w-full btn bg-indigo-500 hover:bg-indigo-600 text-white py-2 rounded-md ">Save</button>
                </form>
            </div>
        </div>
    );
}